const startFormatterSameYear = new Intl.DateTimeFormat(undefined, {
  month: 'long',
  day: 'numeric',
});

const startFormatterWithYear = new Intl.DateTimeFormat(undefined, {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
});

const endFormatter = new Intl.DateTimeFormat(undefined, {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
});

export function formatDigestWindow(start: Date, end: Date) {
  const sameYear = start.getFullYear() === end.getFullYear();
  const startFormatter = sameYear
    ? startFormatterSameYear
    : startFormatterWithYear;

  return `${startFormatter.format(start)} to ${endFormatter.format(end)}`;
}
